/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BisacMainDto from './BisacMainDto';

/**
 * The BisacDto model module.
 * @module model/BisacDto
 * @version v1.0.0
 */
class BisacDto {
    /**
     * Constructs a new <code>BisacDto</code>.
     * @alias module:model/BisacDto
     */
    constructor() { 
        
        BisacDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BisacDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BisacDto} obj Optional instance to populate.
     * @return {module:model/BisacDto} The populated <code>BisacDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BisacDto();

            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('main')) {
                obj['main'] = ApiClient.convertToType(data['main'], [BisacMainDto]);
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} code
 */
BisacDto.prototype['code'] = undefined;

/**
 * @member {String} id
 */
BisacDto.prototype['id'] = undefined;

/**
 * @member {Array.<module:model/BisacMainDto>} main
 */
BisacDto.prototype['main'] = undefined;

/**
 * @member {String} name
 */
BisacDto.prototype['name'] = undefined;

/**
 * @member {Number} seq
 */
BisacDto.prototype['seq'] = undefined;






export default BisacDto;

